<template><div /></template>

<script setup lang="ts">
import { onMounted } from "vue";
import { useRouter } from "vue-router";
import { practitionerHttpService } from "../../app/practitioner-portal/store/practitioner-http-service";
import { clearAuthState } from "../../app/practitioner-portal/auth/clear-auth-state";
import { store } from "../../store";

const router = useRouter();

onMounted(async () => {
  if (!store.state.isAuthenticated) {
    router.push({ name: "Auth" });
    return;
  }

  try {
    await practitionerHttpService.post("/api/internal/auth/logout");
  } catch {
    // Session already expired -- 401 interceptor handles cleanup
  }

  clearAuthState();
  router.push({ name: "Auth" });
});
</script>
